import request from './request'

export function getOrderStatusHistoryList(params = {}) {
  return request({
    url: '/order/statusHistory/list',
    method: 'get',
    params
  })
}
